/*import axios from 'axios';
import config from 'config';
import { Effects, loop } from 'redux-loop';
import { finalize } from "actions/URLfinalizer";*/

import {
  //UPDATE_USER,
  USER_UPDATE_COMPLETED,
  //updateFailed,
  //updateCompleted,
  RECEIVE_USER
  //DELETE_WIDGET,
} from 'actions/myaccount'

const initialState = {
  loading: false,
  user: null
}

/*function updateUser(user) {
  return axios.post(finalize(config.api.root + `/api/user/${user.id}`))
    .then(updateCompleted)
    .catch(updateFailed)
}*/

export default (state = initialState, action) => {

  switch (action.type) {
    //case UPDATE_USER: {
    //  return loop (
    //    Object.assign({}, initialState, {loading: true}),
    //    Effects.promise(updateUser)
    //  )
    //}

    case USER_UPDATE_COMPLETED: {
      return Object.assign({}, state, {
        loading: false,
        user: action.data
      });
    }

    case RECEIVE_USER: {
      return Object.assign({}, state, {
        user: action.data
      });
    }

    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/myaccount.js